import { useMutation } from '@tanstack/react-query';

import { ProductionApi } from '../production.api';

export const useGetProductionReCalculations = () => {
  return useMutation({
    mutationFn: ProductionApi.getProductionReCalculations,
  });
};
